module.exports = __webpack_public_path__ + "img/avatar-icon.8c60bba2.svg";